import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Button, Container, Divider, Grid, Header, Input, InputOnChangeData, Message, Segment, Table } from "semantic-ui-react";
import * as Chiamate from '..';
import { ApplicationState } from '../..';
import { Allegato, FileSelector } from '../../archiviazione';
import { Matricola, TipoIntervento } from '../../core-assistenza';
import Notification from '../../notification';
import parse from 'html-react-parser';

type OwnProps = {
    matricola: Matricola,
    tipologia: TipoIntervento,
    idTipoRichiesta: string,
    descrizioneAggiuntiva: string,
    hasArchiviazione: boolean,
    allegati: Allegato[],
    onGoBack: (step: number) => void,
    onImageAdded: (image: Allegato) => void,
    onImageRemoved: (image: Allegato) => void,
}

//https://react-redux.js.org/using-react-redux/static-typing#typing-the-connect-higher-order-component
const connector = connect(
    (state: ApplicationState) => ({
        tipiRichiesta: state.chiamate.tipiRichiestaRiepiloghi.riepiloghi.tipiRichiesta,
        userEmail: state.core.auth.user!.profile!.email!,        
        referenteObbligatorio: state.core.anagrafiche.anagrafica!.referente,
    }),
    Chiamate.actions
);
type PropsFromRedux = ConnectedProps<typeof connector>

type RiepilogoProps =
    PropsFromRedux &
    OwnProps

type RiepilogoState = {
    email: string,
    isEmailValid: boolean,
    referente: string,
    isReferenteValid: boolean,
}

class Riepilogo extends React.Component<RiepilogoProps, RiepilogoState> {
    constructor(props: RiepilogoProps) {
        super(props);

        this.state = {
            email: props.userEmail || '',
            isEmailValid: true,
            referente: props.matricola.referente,
            isReferenteValid: props.referenteObbligatorio ? false : true,
        }
    }

    render() {
        const { tipiRichiesta, matricola, idTipoRichiesta, descrizioneAggiuntiva, onGoBack } = this.props;
        const tipoRichiesta = tipiRichiesta.find(item => item.idTipoRichiesta === idTipoRichiesta);
        const descrizioneAggiuntivaFormattata = (
            descrizioneAggiuntiva.split(/\r?\n/).map((s, index) => <span key={index}>{s} <br /></span>)
        )

        return (
            <>
            <Grid.Row>
                <Grid.Column computer='7' tablet='14' mobile='16'>
                    <Message
                        icon="inbox"
                        header="Invia la segnalazione"
                        content="Prima di inviare verifica i dati della tua segnalazione."
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column computer='7' tablet='14' mobile='16'>
                    <Header as='h5' attached='top' block>Informazioni selezionate</Header>
                    <Table attached definition fixed unstackable>
                        <Table.Body>
                            <Table.Row key={1}>
                                <Table.Cell width='5'>Numero macchina</Table.Cell>
                                <Table.Cell>{matricola.numeroMacchina}</Table.Cell>
                            </Table.Row>
                            <Table.Row key={2}>
                                <Table.Cell>Matricola</Table.Cell>
                                <Table.Cell>{matricola.codice}</Table.Cell>
                            </Table.Row>
                            <Table.Row key={3}>
                                <Table.Cell>Modello</Table.Cell>
                                <Table.Cell>{matricola.descrizione}</Table.Cell>
                            </Table.Row>
                            <Table.Row key={4}>
                                <Table.Cell>Ubicazione</Table.Cell>
                                <Table.Cell>{parse(matricola.ubicazione)}</Table.Cell>
                            </Table.Row>
                            <Table.Row key={5}>
                                <Table.Cell>Tipo richiesta</Table.Cell>
                                <Table.Cell>{tipoRichiesta!.descrizione}</Table.Cell>
                            </Table.Row>
                            <Table.Row key={6}>
                                <Table.Cell>Dettagli</Table.Cell>
                                <Table.Cell>{descrizioneAggiuntivaFormattata}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column computer='7' tablet='14' mobile='16'>
                    <Header as='h5' attached='top' block>Ulteriori dettagli</Header>
                    <Segment attached>
                        <Input
                            fluid
                            label={{ icon: 'at' }}
                            labelPosition="left corner"
                            error={!this.state.isEmailValid}
                            placeholder="Indirizzo posta"
                            value={this.state.email}
                            onChange={this.onEmailChange}
                        />
                        <Divider hidden />
                        <Input
                            fluid
                            label={{ icon: 'info' }}
                            error={!this.state.isReferenteValid}
                            labelPosition="left corner"
                            placeholder="Referente"
                            value={this.state.referente}
                            onChange={this.onReferenteChange}
                        />
                    </Segment>
                </Grid.Column>
            </Grid.Row>
            {this.props.hasArchiviazione && this.renderAggiungiAllegati()}
            <Grid.Row>
                <Grid.Column computer='7' tablet='14' mobile='16'>
                    <Container textAlign='center'>
                        <Button content='Indietro' primary onClick={() => onGoBack(1)} style={{ marginRight: 15 }} />
                        <Button content="Invia segnalazione" icon="mail outline" primary onClick={this.onSendTicket} />
                    </Container>
                </Grid.Column>
            </Grid.Row>
            </>
        );
    }

    /*renderAggiungiAllegati = () => (
        <></>
    )*/

    renderAggiungiAllegati = () => (
        <Grid.Row>
            <Grid.Column computer='7' tablet='14' mobile='16'>
                <FileSelector 
                    images={this.props.allegati} 
                    onImageAdded={this.props.onImageAdded}
                    onImageRemoved={this.props.onImageRemoved}
                />
            </Grid.Column>
        </Grid.Row>
    )

    onSendTicket = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();

        var message = '';
        if (!this.state.isEmailValid) {
            message = "L'indirizzo di mail specificato non è valido. \n";
        }
        if (!this.state.isReferenteValid) {
            message += "Aggiungere il referente. \n";
        }

        if (!this.isNullOrWhitespace(message)) {
            Notification.error(message, 'Dati non validi');
            return;
        }

        const { matricola, idTipoRichiesta, descrizioneAggiuntiva, tipologia, allegati } = this.props;

        const fileAllegati = allegati !== undefined && allegati.length > 0 ?
            allegati.map(a => a.file) :
            undefined;

        this.props.saveTicket({
            inviaMail: true,
            email: this.state.email,
            idTipoRichiesta: idTipoRichiesta,
            idSpecifica: matricola.idSpecifica,
            descrizioneAggiuntiva: descrizioneAggiuntiva,
            tipoIntervento: tipologia, // tipo intervento hardware,
            referente: this.state.referente,
            allegati: fileAllegati,
        });
    }

    onReferenteChange = (_: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        let isReferenteValid = true;
        if (this.props.referenteObbligatorio && this.isNullOrWhitespace(data.value)) {
            isReferenteValid = false;
        }

        this.setState({ referente: data.value, isReferenteValid });
    }

    onEmailChange = (_: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        let isEmailValid = true;
        if (!this.validateEmail(data.value)) {
            isEmailValid = false;
        }

        this.setState({ email: data.value, isEmailValid });
    }

    validateEmail = (email: string) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    isNullOrWhitespace = (input: string) => {
        return !input || !input.trim();
    }
}

/*
    https://stackoverflow.com/questions/58623339/inferring-mapped-props-when-using-typescript-and-react-redux/58630099#58630099
*/

export default connector(Riepilogo);